import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'transaction_type_label', label: 'Transaction Type' },
  { key: 'sub_ledger_total', label: 'Sub-ledger Total', align: 'right', type: 'money' },
  { key: 'gl_posted_total', label: 'GL Posted Total', align: 'right', type: 'money' },
  { key: 'variance', label: 'Variance', align: 'right', type: 'money' },
];

export function ReconciliationReport() {
  return (
    <ReportView
      title="Monthly Sub-ledger to GL Reconciliation"
      description="Per transaction type, compares the true source-ledger total for the period against what has actually posted to GL. Defaults to the current month — use the date range to check a different period."
      endpoint="/reports/gl/reconciliation"
      columns={COLUMNS}
      filters={['dateRange']}
    />
  );
}
